module.exports = __webpack_public_path__ + "img/watches-icon.17859805dbd0c41861138cedd6dd7e7a.svg";